import axios from "axios";
import React, { useEffect, useState } from "react";
import Menu from "../Navigations/MenuProComponent";
import Navigation from "../Navigations/NavigationComponent";
import LoadingComponent from "../Navigations/Loading";
let timer: NodeJS.Timeout;

const BasePage = (props: any) => {
    const [redirect, setRedirect] = useState(false);
    const [usuario, setUsuario] = useState({ nome: '' });
    const [height, setHeight] = useState(0);
    const [toggleMenuCollapse, setToggleMenuCollapse] = useState(true);

    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        document.body.style.backgroundImage = "";
        setHeight((window.innerHeight) - 60 );
        window.addEventListener('resize', () => setHeight((window.innerHeight) - 60 ));

        (async () => {
            try {
                let response = await axios.get('usuario');
                setUsuario(response.data);
            } catch (error) {
                setRedirect(true);
            }

            localRecursiveEvent();
        })();
    }, []);

    function localRecursiveEvent() {
        if (props.recursiveEvent == null)
        {
            return;
        }

        clearTimeout(timer);
        try {
            timer = setTimeout(() => { props.recursiveEvent(); localRecursiveEvent(); }, 30000);
        } catch (ex) {
            timer = setTimeout(() => { props.recursiveEvent(); localRecursiveEvent(); }, 10000);
        }
    }

    return (
        <>
            <LoadingComponent show={props.loading} />
            <Navigation usuario={usuario} setToggleMenuCollapse={() => setToggleMenuCollapse(!toggleMenuCollapse)} />

            <div className={`central-page container-fluid${preferences.darkMode ? ' bg-black':''}`}>
                <div className="row">
                    <Menu usuario={usuario} toggleMenuCollapse={toggleMenuCollapse} closeMenu={() => setToggleMenuCollapse(true)} />
                    <main id="main-height" className={preferences.darkMode?"body-center-page bg-black":"body-center-page"} style={{width:'96%', height: height}}>
                        {props.children}
                    </main>
                </div>
            </div>
        </>
    );
}

export default BasePage;